import { render, staticRenderFns } from "./folder-or-sales-plan-multiselect-ajax.vue?vue&type=template&id=ce884fa0&scoped=true&"
import script from "./folder-or-sales-plan-multiselect-ajax.vue?vue&type=script&lang=js&"
export * from "./folder-or-sales-plan-multiselect-ajax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce884fa0",
  null
  
)

export default component.exports